export default __webpack_public_path__ + "static/media/Shatush of the Bloodmoon.9ae9a363.jpg";